/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PoolGroupModule
 */

import {
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';

import {
    Pool as PoolType,
} from 'object-types';

import { StateService } from '@uirouter/core';
import { POOL_DETAIL_HS_INSIGHTS } from 'state-names';
import { StringService } from 'string-service';
import { Pool } from 'items/pool.item.factory';
import {
    IPoolRuntime,
} from 'ng/lazy-loaded-modules/vs-topology-page/components/vs-topology-page/vs-topology-page.store';

/**
 * @description Pool health score component.
 * @author Nitesh Kesarkar, Deepak Chaudhary
 */
@Component({
    selector: 'pool-health-score',
    templateUrl: './pool-health-score.component.html',
})
export class PoolHealthScoreComponent implements OnInit, OnDestroy {
    @Input()
    public poolRef: string;

    public pool: IPoolRuntime;

    public poolItem: Pool;

    public vsId: string;

    constructor(
        private readonly $state: StateService,
        private readonly stringService: StringService,
        @Inject(Pool)
        private readonly PoolClass: typeof Pool,
    ) { }

    /** @override */
    public async ngOnInit(): Promise<void> {
        const { stringService } = this;

        const poolId = stringService.slug(this.poolRef);

        this.poolItem = new this.PoolClass({
            objectName: 'pool-inventory',
            id: poolId,
        });

        await this.poolItem.load();

        const pool = this.poolItem.getDataCopy();

        const {
            config,
            health_score: healthScore,
            runtime,
        } = pool;

        this.pool = {
            config: {
                name: config.name,
                type: PoolType,
                url: config.url,
                uuid: config.uuid,
            },
            health_score: healthScore,
            runtime,
        };

        this.vsId = this.poolItem.getVSId();
    }

    /**
     * Navigate to the health page for current vs and pool.
     */
    public navigateToHealthPage(): void {
        const {
            $state,
            pool,
            vsId,
        } = this;

        $state.go(POOL_DETAIL_HS_INSIGHTS, {
            vsId,
            poolId: pool.config.uuid,
        });
    }

    /** @override */
    public ngOnDestroy(): void {
        this.poolItem.destroy();
    }
}
